export class DistanceModel {
    //distancia en metros
    distance?: number | null;
    //duracion hasta el destino en horas
    duration?: number;

    constructor(distance: number | null, duration: number) {
        this.distance = distance;
        this.duration = duration;
    }

    distanceKm(): number {
        return this.distance ? (this.distance / 1000) : 0;
    };

    durationMinutes(): number {
        return this.duration && this.distance == null ? this.duration : this.duration && this.distance ? (this.duration / 60) : 0;
    }
}